
let currentUrl = window.location.pathname;
  if (currentUrl.includes("/collections/") || currentUrl.includes("/search")){
  let lastScrollTop = 0;
  const bottomNav = document.getElementsByClassName('bottomNavigationPosition');  
  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    if (window.innerWidth <= 768) { 
      console.log(document.documentElement.scrollTop , "document.documentElement.scrollTop");      
      console.log(currentScroll, " currentScroll");
      console.log(lastScrollTop, " lastScrollTop");
      if (currentScroll > 100) {
         $("body")?.addClass('scroll_top');
          if (lastScrollTop < currentScroll) {
            $("body")?.addClass('visible_bottomBarNav');
          } else{
              $("body")?.removeClass('visible_bottomBarNav');
          }        
      } else {
         $("body")?.removeClass('scroll_top');
      }
    }
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; 
  });
}